// import React, { useEffect, useState } from "react";
// import "./Users.css"

// const Users = () => {
//   const [users, setUsers] = useState([]);
//   const [editingUserId, setEditingUserId] = useState(null);
//   const [formData, setFormData] = useState({ username: "", email: "" });
//   const [showModal, setShowModal] = useState(false);
//   const [loading, setLoading] = useState(false);

//   // Fetch all users
//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const fetchUsers = async () => {
//     try {
//       const res = await fetch("http://localhost:3050/api/users/getallusers");
//       const data = await res.json();
//       setUsers(data.users);
//     } catch (error) {
//       console.error("Error fetching users:", error);
//     }
//   };

//   // Handle edit button click
//   const handleEditClick = async (userId) => {
//     setEditingUserId(userId);
//     setShowModal(true);
//     setLoading(true);
//     try {
//       const res = await fetch(`http://localhost:3050/api/users/user/${userId}`);
//       const data = await res.json();
//       setFormData({ username: data.username, email: data.email });
//     } catch (error) {
//       console.error("Error fetching user:", error);
//     }
//     setLoading(false);
//   };

//   // Update form data
//   const handleChange = (e) => {
//     setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
//   };

//   // Submit updated user
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       await fetch(`/api/users/${editingUserId}`, {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(formData),
//       });
//       fetchUsers();
//       setShowModal(false);
//       setFormData({ username: "", email: "" });
//       setEditingUserId(null);
//     } catch (error) {
//       console.error("Error updating user:", error);
//     }
//   };

//   return (
//     <div>
//       <h2>User List</h2>
//       <ul>
//         {users.map((user) => (
//           <li key={user.user_id}>
//             {user.username} - {user.email}
//             <button onClick={() => handleEditClick(user.user_id)}>Edit</button>
//           </li>
//         ))}
//       </ul>

//       {showModal && (
//         <div className="modal">
//           <h3>Edit User</h3>
//           {loading ? (
//             <p>Loading user data...</p>
//           ) : (
//             <form onSubmit={handleSubmit}>
//               <label>Username:</label>
//               <input
//                 name="username"
//                 value={formData.username}
//                 onChange={handleChange}
//                 required
//               />
//               <label>Email:</label>
//               <input
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 required
//               />
//               <button type="submit">Update</button>
//               <button type="button" onClick={() => setShowModal(false)}>
//                 Cancel
//               </button>
//             </form>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Users;

import React, { useEffect, useState } from "react";
import "./Users.css";
import AdminRegisterForm from "./AdminRegisterForm";
// import API_URL from '../../config';

const Users = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  // console.log("API URL:", process.env.REACT_APP_API_URL);
  const [users, setUsers] = useState([]);
  const [email, setEmail] = useState([]);
  const [editingUserId, setEditingUserId] = useState(null);
  const [viewingUser, setViewingUser] = useState(null);
  const [formData, setFormData] = useState({ username: "", email: "" });
  const [showEditModal, setShowEditModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const [showEditAdminModal, setShowEditAdminModal] = useState(false);
  const [editingAdminUserId, setEditingAdminUserId] = useState(null);

  useEffect(() => {
    fetchUsers();
  }, []);
const token = localStorage.getItem("token");
  const fetchUsers = async () => {
    try {
      const res = await fetch(`${API_URL}/admin/getalladmins`);
      const data = await res.json();
      setUsers(data.admins);
      setEmail(data.admins[0].email);
      // console.log(data.admins[0].email);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleEditClick = async (userId) => {
    setEditingUserId(userId);
    setShowEditModal(true);
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/admin/getadminbyid/${userId}`);
      const data = await res.json();
      setFormData({
        username: data.username,
        email: data.email,
        role: data.role,
      });
    } catch (error) {
      console.error("Error fetching user:", error);
    }
    setLoading(false);
  };

  const handleViewClick = async (userId) => {
    try {
      const res = await fetch(`${API_URL}/admin/getadminbyid/${userId}`);
      const data = await res.json();
      setViewingUser(data);
      setShowViewModal(true);
    } catch (error) {
      console.error("Error viewing user:", error);
    }
  };

  // const handleDeleteClick = async (userId) => {
  //   const confirmDelete = window.confirm(
  //     "Are you sure you want to delete this user?"
  //   );
  //   if (!confirmDelete) return;

  //   try {
  //     await fetch(`${API_URL}/admin/deleteadmin/${userId}`, {
  //       method: "DELETE",
  //     });
  //     fetchUsers();
  //   } catch (error) {
  //     console.error("Error deleting user:", error);
  //   }
  // };
const handleDeleteClick = async (userId) => {

  const confirmDelete = window.confirm(
    "Delete this admin?\n\nThis action cannot be undone."
  );

  if (!confirmDelete) return;

  try {

    const response = await fetch(
      `${API_URL}/admin/deleteadmin/${userId}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = await response.json();

    if (!response.ok) {
      alert(data.message);
      return;
    }

    alert(data.message);

    fetchUsers();

  } catch (error) {
    console.error(error);
    alert("Delete failed.");
  }

};



  const adminemail = `${email}`;

  // const handleDeleteClickhard = async () => {
  //   const confirmDelete = window.confirm(
  //     "Are you sure you want to delete this user?"
  //   );
  //   if (!confirmDelete) return;

  //   try {
  //     await fetch(`${API_URL}/admin/deletehard/${adminemail}`, {
  //       method: "DELETE",
  //     });
  //     fetchUsers();
  //   } catch (error) {
  //     console.error("Error deleting user:", error);
  //   }
  // };
  const handleDeleteClickhard = async (email) => {

  const confirmDelete = window.confirm(
    "⚠ WARNING!\n\nThis permanently deletes the admin.\n\nContinue?"
  );

  if (!confirmDelete) return;

  const finalConfirm = window.confirm(
    "FINAL WARNING!\n\nThis cannot be undone.\n\nPress OK to permanently delete."
  );

  if (!finalConfirm) return;

  try {

    const response = await fetch(
      `${API_URL}/admin/deletehard/${email}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "x-confirm": "DELETE_ALL",
        },
      }
    );

    const data = await response.json();

    if (!response.ok) {
      alert(data.message);
      return;
    }

    alert(data.message);

    fetchUsers();

  } catch (error) {
    console.error(error);
    alert("Hard delete failed.");
  }

};

  const handleEditAdminClick = async (userId) => {
    setEditingAdminUserId(userId);
    setShowEditAdminModal(true);
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/admin/getadminbyid/${userId}`);
      const data = await res.json();
      setFormData({
        username: data.username,
        email: data.email,
        role: data.role,
      });
    } catch (error) {
      console.error("Error fetching user:", error);
    }
    setLoading(false);
  };

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     await fetch(`${API_URL}/admin/updateadmin/${editingUserId}`, {
  //       method: "PUT",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(formData),
  //     });
  //     fetchUsers();
  //     setShowEditModal(false);
  //     setFormData({ username: "", email: "", role: "" });
  //     setEditingUserId(null);
  //   } catch (error) {
  //     console.error("Error updating user:", error);
  //   }
  // };
  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const response = await fetch(
      `${API_URL}/admin/updateadmin/${editingUserId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      alert(data.message);
      return;
    }

    alert("Admin updated successfully.");

    fetchUsers();
    setShowEditModal(false);
    setFormData({
      username: "",
      email: "",
      role: "",
    });
    setEditingUserId(null);

  } catch (error) {
    console.error(error);
    alert("Failed to update admin.");
  }
};

  return (
    <div className="user-container">
      <h2>Admin list</h2>
      <button onClick={() => handleEditAdminClick()}>Admin Register</button>
      <table border="1" cellPadding="10">
        <thead>
          <tr>
            <th>User ID</th>
            <th>Username</th>
            <th>Email</th>
            <th>Role</th>

            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.id}>
              <td>{user.id}</td>
              <td>{user.username}</td>
              <td>{user.email}</td>
              <td>{user.role}</td>
              <td>
                <button onClick={() => handleViewClick(user.id)}>View</button>{" "}
                <button onClick={() => handleEditClick(user.id)}>Edit</button>{" "}
                <button onClick={() => handleDeleteClick(user.id)}>
                  Delete
                </button>
                {/* <button onClick={() => handleDeleteClickhard(user.email)}>
                  Delete hard
                </button> */}
                <button onClick={() => handleDeleteClickhard(user.email)}>
    Delete Hard
</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Edit Modal */}
      {showEditModal && (
        <div className="modal">
          <div className="modal-content">
            <h3>Edit User</h3>
            {loading ? (
              <p>Loading user data...</p>
            ) : (
              <form onSubmit={handleSubmit}>
                <label>Username:</label>
                <input
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  required
                />
                <label>Email:</label>
                <input
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                <label>Role:</label>
                <input
                  name="role"
                  value={formData.role}
                  onChange={handleChange}
                  required
                />
                <button type="submit">Update</button>
                <button type="button" onClick={() => setShowEditModal(false)}>
                  Cancel
                </button>
              </form>
            )}
          </div>
        </div>
      )}

      {/* View Modal */}
      {showViewModal && viewingUser && (
        <div className="modal">
          <div className="modal-content">
            <h3>User Details</h3>
            <p>
              <strong>ID:</strong> {viewingUser.id}
            </p>
            <p>
              <strong>Username:</strong> {viewingUser.username}
            </p>
            <p>
              <strong>Email:</strong> {viewingUser.email}
            </p>
            <button onClick={() => setShowViewModal(false)}>Close</button>
          </div>
        </div>
      )}
      {/* admin register */}
      {showEditAdminModal && (
        <div className="modal">
          <div className="modal-content">
            {loading ? (
              <p>Loading user data...</p>
            ) : (
              // <form onSubmit={handleSubmit}>
              //   <label>Username:</label>
              //   <input
              //     name="username"
              //     value={formData.username}
              //     onChange={handleChange}
              //     required
              //   />
              //   <label>Email:</label>
              //   <input
              //     name="email"
              //     value={formData.email}
              //     onChange={handleChange}
              //     required
              //   />
              //   <label>Role:</label>
              //   <input
              //     name="role"
              //     value={formData.role}
              //     onChange={handleChange}
              //     required
              //   />
              //   <button type="submit">Update</button>
              //   <button type="button" onClick={() => setShowEditModal(false)}>
              //     Cancel
              //   </button>
              // </form>
              <div>
                <AdminRegisterForm />
                <button onClick={() => setShowEditAdminModal(false)}>
                  Close
                </button>{" "}
              </div>
            )}
          </div>
        </div>
      )}
      {/* admin register */}
    </div>
  );
};

export default Users;
